// Shared time utilities for consistent sorting across components

// Convert 12-hour time string to minutes since midnight for sorting
export const getTimeSortValue = (timeString) => {
  if (!timeString || timeString === 'No time') return 999999; // No time goes to end
  
  try {
    // Match format like "7:30 AM" or "12:00 PM"
    const match = timeString.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) return 999999;
    
    const hour = parseInt(match[1], 10);
    const minute = parseInt(match[2], 10);
    const period = match[3].toUpperCase();
    
    // Convert to 24-hour format
    let hour24 = hour;
    if (period === 'PM' && hour !== 12) {
      hour24 = hour + 12;
    } else if (period === 'AM' && hour === 12) {
      hour24 = 0;
    }
    
    return hour24 * 60 + minute;
  } catch (error) {
    return 999999;
  }
};

// Sort items by time (earliest first)
// Also respects display_order if present (lower display_order comes first)
export const sortItemsByTime = (items) => {
  return [...items].sort((a, b) => {
    // First, sort by display_order if both have it
    const orderA = a.display_order ?? 999999;
    const orderB = b.display_order ?? 999999;
    
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    
    // Then sort by time
    const timeA = a.time || a.timeString || '';
    const timeB = b.time || b.timeString || '';
    return getTimeSortValue(timeA) - getTimeSortValue(timeB);
  });
};

// Sort items by time using time parts (for DayAgendaPanel)
export const sortItemsByTimeParts = (items) => {
  return [...items].sort((a, b) => {
    if (!a.timeHour || !a.timeMinute) return 1; // No time goes to end
    if (!b.timeHour || !b.timeMinute) return -1;
    
    const hourA = parseInt(a.timeHour, 10);
    const minuteA = parseInt(a.timeMinute, 10);
    const periodA = a.timePeriod || 'AM';
    
    const hourB = parseInt(b.timeHour, 10);
    const minuteB = parseInt(b.timeMinute, 10);
    const periodB = b.timePeriod || 'AM';
    
    // Convert to 24-hour format
    let hour24A = hourA;
    if (periodA === 'PM' && hourA !== 12) {
      hour24A = hourA + 12;
    } else if (periodA === 'AM' && hourA === 12) {
      hour24A = 0;
    }
    
    let hour24B = hourB;
    if (periodB === 'PM' && hourB !== 12) {
      hour24B = hourB + 12;
    } else if (periodB === 'AM' && hourB === 12) {
      hour24B = 0;
    }
    
    const timeValueA = hour24A * 60 + minuteA;
    const timeValueB = hour24B * 60 + minuteB;
    
    return timeValueA - timeValueB;
  });
};
